import { createRouter, createWebHistory } from 'vue-router';
import SimpleCoinMain from '../components/views/SimpleCoinMain.vue';
import SystemSetup from '../components/views/SystemSetup.vue';
import About from '../components/views/About.vue';
import NotFound from '../components/views/error/404.vue';
import PrivacyPolicy from '../components/views/PrivacyPolicy.vue';
import TermsOfService from '../components/views/TermsOfService.vue';
import Guide from '../components/views/Guide.vue';
import Info from '../components/views/Info.vue';
import Info1 from '../components/views/infoContent/Info1.vue';
import RealTimeChat from '../components/views/RealTimeChat.vue';


const routes = [
  {
  path: '/',
  name: 'root',
  component: SimpleCoinMain,
  },
  {
    path: '/SimpleCoinMain',
    name: 'SimpleCoinMain',
    component: SimpleCoinMain,
  },
  {
    path: '/RealTimeChat',
    name: 'RealTimeChat',
    component: RealTimeChat,
  },
  {
    path: '/Guide',
    name: 'Guide',
    component: Guide,
  },
  {
    path: '/SystemSetup',
    name: 'SystemSetup',
    component: SystemSetup,
  },
  {
    path: '/About',
    name: 'About',
    component: About,
  },
  
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
  },
  {
    path: '/TermsOfService',
    name: 'TermsOfService',
    component: TermsOfService,
  },
  {
    path: '/Info',
    name: 'Info',
    component: Info,
  },
  {
    path: '/Info1',
    name: 'Info1',
    component: Info1,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
